import React from "react";
import { Box } from "@mui/material";
import "./awardIcons.css";

export function AwardIcon({ iconText, size = 24, sx, ...props }) {
    const text = String(iconText || "").trim().slice(0, 1);
    if (!text) return null;

    return (
        <Box
            component="span"
            {...props}
            className="award-jadax-icon"
            sx={{
                width: size,
                height: size,
                color: "#344b7d",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "jadax, sans-serif",
                fontSize: size,
                fontWeight: 400,
                lineHeight: 1,
                flexShrink: 0,
                ...sx,
            }}
        >
            {text}
        </Box>
    );
}

export function AwardBadge({ award, size = 20, sx }) {
    const label = award?.label_de || award?.name || "";
    if (!label) return null;

    return (
        <Box
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.6,
                minHeight: size + 2,
                color: "#263238",
                fontSize: 13,
                fontWeight: 500,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                ...sx,
            }}
        >
            <AwardIcon iconText={award.icon_text} size={size} sx={{ color: "#344b7d" }} />
            <Box component="span">{label}</Box>
        </Box>
    );
}
